import styled from "@emotion/styled";

export const StandardCardGridContainer = styled.div({
    // layout
    display: 'flex',

    // flex
    flex: 1,
})